import React from "react";
import ReactDOM from "react-dom/client";  // Updated import path
import "./index.css";
import { i18nReady } from "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Suppress browser install mini-infobar so users are not interrupted on first visit.
window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
});

// Create a root using createRoot.
const root = ReactDOM.createRoot(document.getElementById("root"));

i18nReady.then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
